<template>
  <div class="MyAccount">
    <p class="pageTop" v-if="!mobileFlag">
      <span class="signalTitle" v-show="$route.path == '/MyAccount'">
        {{ checkPortfolio.portfolioName + " " + $t("SignalSource_Detail") }}
        <div
          class="refreshListBtnDiv"
          v-show="['follow', 'refill'].includes(activeName)"
        >
          <el-button class="confirmDialogBtn" @click="refresh()">
            {{ $t("Common_Operation_Refresh") }}
            <i class="el-icon-refresh-right"></i>
          </el-button>
        </div>
      </span>
    </p>

    <div class="PageCommon">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane   v-if="checkPortfolio.status == 1" :label="$t('SignalSource_BaseInfo')" name="signalBaseInfo">
          <signal-base-info v-if="activeName === 'signalBaseInfo'"  />
        </el-tab-pane>
        <el-tab-pane   v-if="checkPortfolio.status == 0" :label="$t('SignalSource_BaseInfo')" name="stopSignalBaseInfo">
          <StopSignalBaseInfo v-if="activeName === 'stopSignalBaseInfo'"  />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('Common_TableTitle_FollowAccount')"
          name="follow"
          v-if="checkPortfolio.status == 1"
        >
          <follow-account ref="followAccount" @GoHistory="goHistoryProfit" />
        </el-tab-pane>
        <!-- <el-tab-pane
          :label="$t('ManualReplenishment_ManualReplenishment')"
          name="refill" v-if="checkPortfolio.status == 1"
        >
          <manual-refill ref="refill" />
        </el-tab-pane> -->
        <el-tab-pane
          :label="$t('Menu_Signal_HistoricalProfit')"
          name="signalHistoricalProfit"
        >
          <SignalHistoricalProfit
            v-if="activeName == 'signalHistoricalProfit'"
          />
        </el-tab-pane>
        <el-tab-pane
          :label="$t('Share_Link')"
          name="shareLink"
          v-if="checkPortfolio.status == 1"
        >
          <ShareLink v-if="activeName === 'shareLink'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FollowAccount from "@/views/pages/FollowAccount.vue";
//import ManualRefill from "@/views/pages/ManualRefill.vue";
import SignalList from "@/components/common/SignalList.vue";
import SignalBaseInfo from "@/views/pages/SignalDetail/SignalBaseInfo";
import StopSignalBaseInfo from "@/views/pages/SignalDetail/StopSignalBaseInfo";
import SignalHistoricalProfit from "@/views/pages/SignalDetail/SignalHistoricalProfit";
import ShareLink from "@/views/pages/SignalDetail/ShareLink";

export default {
  name: "MyAccount",
  components: {
    FollowAccount,
    // ManualRefill,
    SignalList,
    SignalBaseInfo,
    StopSignalBaseInfo,
    SignalHistoricalProfit,
    ShareLink,
  },
  computed: {
    ...mapState(["checkPortfolio", "activeTab", "mobileFlag"]),
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5,
      tableSearchForm: {
        Account: "",
        DateRange: "",
      },
      activeName: "signalBaseInfo",
    };
  },
  created() {
    this.activeName = this.activeTab;
  },
  methods: {
    handleClick(tab, event) {
      this.$store.commit("setActiveTab", tab.name);
      if (tab.name == "follow") {
        const followAccount = this.$refs.followAccount;
        const pageSize = followAccount ? followAccount.pageSize : 5;
        if (followAccount) {
          followAccount.getData(1, pageSize);
        }
      } else if (tab.name == "refill") {
        this.$refs.refill.getMainList();
      }
    },
    refresh() {
      if (this.activeName == "follow") {
        const followAccount = this.$refs.followAccount;
        if (followAccount) {
          followAccount.getData(
            followAccount.currentPage,
            followAccount.pageSize
          );
        }
      } else if (this.activeName == "refill") {
        this.$refs.refill.getMainList();
      }
    },
    goHistoryProfit(name, account) {
      this.activeName = name;
      this.$router.push({ path: "/MyAccount", query: { account } });
    },
  },
};
</script>
<style lang="less" scoped>
.MyAccount {
  .signaListPosition {
    position: absolute;
    right: 10px;
    top: 4px;
  }
  .PageCommon {
    padding-top: 0;
  }
  .pageTop {
    .signalTitle {
      display: flex;
      flex-direction: row;
      align-items: center;
      .refreshListBtnDiv {
        position: relative;
        margin-left: 10px;
        .confirmDialogBtn {
          color: #fff;
          text-align: center;
          font-family: "PingFangSC-Medium";
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 12px;
          padding: 8px 10px;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .MyAccount {
    .PageCommon {
      padding-top: 20px;
    }
  }
}
</style>
